const googleConfig = {
  scriptSrc: "https://securepubads.g.doubleclick.net/tag/js/gpt.js",
  scriptId: "saved-items-letter-box-advert",
  adId: "div-gpt-ad-1762877821019-0",
  adUnitPath: "/78607200/web/com/saved-items",
  fetchMarginPercent: 500,
  renderMarginPercent: 300,
  mobileMarginScaling: 1.6,
  forceSafeIframe: true,
  screen_breakpoint_tablet: 1024,
  screen_breakpoint_mobile: 768,
  adverts_position: [2, 3, 4],
  abTestLabel: "saved-list-googles-adverts"
};

export default googleConfig;
